import React, { PureComponent } from 'react';

import { FormattedMessage } from 'react-intl';

import CustomThemeButton from '@atlaskit/button/custom-theme-button';

import messages from '../i18n';
import * as styles from '../styles';
import { CloneClientType, CloneClientEvent } from '../types';
import { DesktopOS } from '../utils/get-desktop-os';

export type CloneClientProps = {
  client: CloneClientType;
  clientHref: string;
  currentOS: DesktopOS;
  cloneHref: string | undefined;
  onCloneClient: CloneClientEvent | undefined;
};

enum ClientDisplayNames {
  Sourcetree = 'Sourcetree',
  Xcode = 'Xcode',
  VSCode = 'VS Code',
}

enum OsDisplayNames {
  mac = 'macOS',
  win = 'Windows',
  linux = 'Linux',
}

export default class CloneClient extends PureComponent<CloneClientProps> {
  render() {
    const { client, clientHref, currentOS, cloneHref, onCloneClient } =
      this.props;
    // @ts-ignore TODO: fix noImplicitAny error here
    const cloneMessage = messages[`cloneIn${client}Link`];
    // @ts-ignore TODO: fix noImplicitAny error here
    const clientHrefMessage = messages[`cloneIn${client}Msg`];

    return (
      cloneHref && (
        <styles.CloneClient>
          {clientHrefMessage && (
            <FormattedMessage
              {...clientHrefMessage}
              values={{
                os: OsDisplayNames[currentOS],
                link: (
                  <a href={clientHref} target="_blank">
                    {ClientDisplayNames[client]}
                  </a>
                ),
              }}
            />
          )}
          {cloneMessage && (
            <styles.ButtonGroup>
              <CustomThemeButton
                href={cloneHref}
                onClick={
                  onCloneClient && (event => onCloneClient(client, event))
                }
                /* @ts-ignore TODO: remove defaultProp type: 'button' in @atlaskit/button */
                type={null}
              >
                <FormattedMessage {...cloneMessage} />
              </CustomThemeButton>
            </styles.ButtonGroup>
          )}
        </styles.CloneClient>
      )
    );
  }
}
